const updatesData = [
  {
    time: '08-01',
    title: '《繁花》全集高清上线',
    desc: '王家卫首部电视剧作品，胡歌马伊琍主演，沪上风云故事，已更新至大结局。',
    tag: '新片上线',
    tagColor: 'primary',
  },
  {
    time: '07-31',
    title: '暑期档影片专题页面上线',
    desc: '整合2024暑期档热门国产电影，《抓娃娃》《默杀》等票房佳作一次看够。',
    tag: '专题更新',
    tagColor: 'accent',
  },
  {
    time: '07-30',
    title: '平台片库突破10万部里程碑',
    desc: '经过三年持续建设，91电影视频片库正式突破10万部国产影视内容。',
    tag: '平台动态',
    tagColor: 'secondary',
  },
  {
    time: '07-29',
    title: '移动端播放体验全面升级',
    desc: '优化手机端H5播放器，提升弱网环境下播放流畅度，新增手势控制功能。',
    tag: '功能更新',
    tagColor: 'secondary',
  },
  {
    time: '07-28',
    title: '《第二十条》正式登陆平台',
    desc: '张艺谋导演现实题材力作，雷佳音马丽主演，探讨法与情的边界。',
    tag: '新片上线',
    tagColor: 'primary',
  },
  {
    time: '07-27',
    title: '「国产悬疑剧」专题热度破百万',
    desc: '悬疑剧专题上线一个月播放量突破百万，成为平台最受欢迎的内容专区。',
    tag: '数据快报',
    tagColor: 'accent',
  },
  {
    time: '07-26',
    title: '《三体》电视剧完整版已更新',
    desc: '根据刘慈欣同名科幻小说改编，国产科幻剧集标杆之作全集上线。',
    tag: '新片上线',
    tagColor: 'primary',
  },
  {
    time: '07-25',
    title: '片库分类体系全新改版',
    desc: '重新梳理影视分类结构，新增导演合集、年代回顾等维度，找片更方便。',
    tag: '功能更新',
    tagColor: 'secondary',
  },
  {
    time: '07-24',
    title: '《飞驰人生2》高清版本上线',
    desc: '韩寒导演沈腾主演，热血赛车喜剧续作，延续前作口碑与票房佳绩。',
    tag: '新片上线',
    tagColor: 'primary',
  },
];

const tagColorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            91电影视频最新动态，不错过每一部新片和每一次升级
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-200"></div>

          <div className="space-y-0">
            {updatesData.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 md:gap-5 pb-5 md:pb-6 last:pb-0">
                <div className="relative z-10 shrink-0 w-[38px] h-[38px] md:w-[46px] md:h-[46px] rounded-full bg-background-50 border-2 border-background-200 flex items-center justify-center">
                  <span className="text-[10px] md:text-xs font-medium text-foreground-600 leading-tight text-center">
                    {item.time}
                  </span>
                </div>

                <div className="flex-1 min-w-0 pt-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-900">
                      {item.title}
                    </h3>
                    <span className={`text-[10px] md:text-xs font-medium px-1.5 py-0.5 rounded whitespace-nowrap ${tagColorMap[item.tagColor]}`}>
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}